import React from 'react'
import Assets from "../../components/Layouts/Assets";
import Style from "./ImageCrop.module.scss";


const FileDropSection = ({ handleDragOver, handleDrop, handleDragOut, handleImageChange, error, type }) => {
    return (
        <div
            className={Style.MiniFileUploadModal__uploadBox}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            onDragLeave={handleDragOut}
        >
            <label htmlFor="uploadImg">
                <figure>
                    <img src={Assets.img_placeholder} alt="" />
                </figure>
                <p>
                    Drag and drop an image, <br /><span>or Browse</span>
                </p>
                {error != "" && <p className={Style.fileSizeError}>{error}</p>}
                <form >
                    <input
                        accept={
                            type == "waterMark"
                                ? "image/png"
                                : "image/apng, image/avif, image/gif, image/jpeg, image/png"
                        }
                        type="file"
                        className="d-none"
                        name="file"
                        id="uploadImg"
                        onChange={handleImageChange}
                    />
                </form>
            </label>
        </div>
    )
}

export default FileDropSection